module.exports = __webpack_public_path__ + "img/SLT_0737-Bearbeitet.1b4489e4.jpg";